export default "__VITE_ASSET__CMvd4gi8__"